import { useState } from 'react';

import { ERROR_CODES } from '@vw-marketing/myvw-portal-web-utils/Utils/Helpers/Constants';

interface UseFormErrorHandlingProps {
  authService: any;
}

export const useFormErrorHandling = ({ 
  authService 
}: UseFormErrorHandlingProps) => {
  const [activeErrorModal, setActiveErrorModal] = useState<boolean>(false);
  const [errorInformation, setErrorInformation] = useState<{
    errorMessage: string;
  }>({ errorMessage: '' });
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleError = (error: any, errorCode: string, errorMessage: string) => {
    console.error(errorMessage, error);
    setActiveErrorModal(true);
    setErrorInformation({ errorMessage });
    authService.apiLog({
      code: errorCode,
      message: error,
    });
  };

  const handleTosError = (error: any) => {
    handleError(
      error, 
      ERROR_CODES.USER_REG.saveUserProfileData, 
      'error.save.tos.message'
    );
  };

  const handleUserDataError = (error: any) => {
    handleError(
      error, 
      ERROR_CODES.USER_REG.updateProfileGqlRequest, 
      'error.save.user.data.message'
    );
  };

  const handleSubmitError = (error: any) => {
    handleError(
      error, 
      ERROR_CODES.USER_REG.saveUserProfileData, 
      'error.save.user.data.message'
    );
  };

  return {
    activeErrorModal,
    setActiveErrorModal,
    errorInformation,
    setErrorInformation,
    isSubmitting,
    setIsSubmitting,
    handleTosError,
    handleUserDataError,
    handleSubmitError
  };
};